import React from 'react';
import renderIf from 'render-if';
import Spinner from '../common/Spinner';
import {
  StartControllerScope,
  useController,
  ApplicationView as view,
} from '@aha-app/mvc';
import CommandsController from './controllers/CommandsController';

const Commands = () => {
  const controller = useController(); // CommandsController
  const { commands, phase } = controller.state;
  const recordContext =
    window.AhaSearchContext && window.AhaSearchContext.recordInfo;

  return (
    <div className='search commands'>
      {recordContext && (
        <div className='command-context'>
          <span className='command-context__record-type'>
            {recordContext.__typename}
          </span>
          {recordContext.referenceNum} {recordContext.name}
        </div>
      )}
      <div className='results'>
        {phase === CommandsController.PHASE_LOADING && <Spinner />}

        {phase === CommandsController.PHASE_CHOOSE_COMMAND && (
          <>
            {commands.map(command => {
              return (
                <a
                  key={command.identifier}
                  className='result'
                  onClick={() => controller.actionChooseCommand(command)}
                  href='#'
                >
                  <div className='result__header'>
                    <div className='result__header__name'>{command.name}</div>
                  </div>
                </a>
              );
            })}

            {renderIf(commands.length === 0)(
              <div className='empty'>
                <h3>No commands found</h3>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

const ControlledCommands = StartControllerScope(
  CommandsController,
  view(Commands)
);

export default ControlledCommands;
